export enum CustomRecurrenceTypeEnum {
  DAY = 'DAY',
  WEEK = 'WEEK'
}
